export const REG_POSITIVE_INTEGER = '^[0-9]{1,}$'
export const REG_ARRAY_OF_PATTERNS = '^((((([a-z]+[*]{0,1})|[*]{1})[.]?)+)[,]?)+$'
export const REG_INVITE_CODE = '^[a-zA-Z0-9]{5,20}$'
export const NON_NEGATIVE_INT = '^[0-9]*$'
export const SI_UNIT_SHORTCUT = '^([a-zA-Z°µ]{1,5}([0-9]{1,3})?[\/\.\· ]?)+$'

export default {
    REG_POSITIVE_INTEGER,
    REG_ARRAY_OF_PATTERNS,
    REG_INVITE_CODE,
    NON_NEGATIVE_INT,
}
